module.exports = __webpack_public_path__ + "static/img/choose_1_2.ab19f2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/choose_1_2.png
// module id = j5tk
// module chunks = 0